import { useLingui } from '@lingui/react/macro';

import InputText from '@/design_system/InputText';
import { OptionalLabel } from '@/design_system/Label/OptionalLabel';

import { PaymentOrRefundStepConfig } from './ExternalPaymentOrRefundModal';

export const PaymentReferenceInput = ({
  paymentReference,
  setPaymentReference,
  stepConfig,
  hasRefashionActions,
  showErrors,
  step,
}: {
  paymentReference: string;
  setPaymentReference: (paymentReference: string) => void;
  stepConfig: PaymentOrRefundStepConfig;
  hasRefashionActions: boolean;
  showErrors: boolean;
  step: 'payment' | 'refund';
}) => {
  const { t } = useLingui();

  if (!stepConfig.fields?.reference?.enabled) {
    return null;
  }

  const isRequired =
    stepConfig.fields?.reference?.required && (step === 'payment' ? hasRefashionActions : true);

  const isInvalid = isPaymentReferenceInvalid({
    paymentReference,
    stepConfig,
    hasRefashionActions,
    step,
  });

  const label =
    step === 'payment'
      ? t({
          id: 'request.step-actions.payment-or-refund.payment-reference.label',
          message: 'Payment reference',
        })
      : t({
          id: 'request.step-actions.refund.refund-reference.label',
          message: 'Refund reference',
        });

  return (
    <InputText
      label={
        <>
          {label}
          {!isRequired && <OptionalLabel />}
        </>
      }
      placeholder={t({
        id: 'request.step-actions.payment-or-refund.payment-reference.placeholder',
        message: 'i.e: 0141490090000',
      })}
      value={paymentReference}
      onChange={setPaymentReference}
      error={
        showErrors && isInvalid
          ? step === 'payment'
            ? t({
                id: 'confirm-client-payment-or-refund-modal.errors.invalid-payment-reference',
                message: 'Please add a valid payment reference',
              })
            : t({
                id: 'confirm-client-payment-or-refund-modal.errors.invalid-refund-reference',
                message: 'Please add a valid refund reference',
              })
          : undefined
      }
    />
  );
};

export const isPaymentReferenceInvalid = ({
  paymentReference,
  stepConfig,
  hasRefashionActions,
  step,
}: {
  paymentReference: string;
  stepConfig: PaymentOrRefundStepConfig;
  hasRefashionActions: boolean;
  step: 'payment' | 'refund';
}): boolean => {
  if (!stepConfig.fields?.reference?.enabled) {
    return false;
  }

  const isRequired =
    stepConfig.fields?.reference?.required && (step === 'payment' ? hasRefashionActions : true);

  if (isRequired && !paymentReference?.length) {
    return true;
  }

  if (stepConfig.fields?.reference.format) {
    if (!paymentReference) {
      return false;
    } else {
      return !paymentReference.match(stepConfig.fields.reference.format);
    }
  }

  return false;
};
